/**
 * Pre-select related card variant selects (Farbe / Größe / …) from the main PDP picker.
 * - On load: all [data-sh-related-card] in .sh-related-products-wrap
 * - On main VARIANT_CHANGE: re-sync
 * - If a value has no matching <option>, that select is left unchanged
 * - Linked color row ([data-sh-related-color-select]): matches main option strings to JSON colorLabel (case-insensitive)
 */
(function () {
  function norm(s) {
    return String(s == null ? '' : s)
      .trim()
      .toLowerCase();
  }

  function findMainProductVariants() {
    return (
      document.querySelector('product-page.product--section product-variants') ||
      document.querySelector('product-page product-variants')
    );
  }

  function getMainProductOptionValues() {
    var pv = findMainProductVariants();
    if (!pv) return [];

    var out = [];
    var variantRequired = pv.hasAttribute('data-variant-required');

    pv.querySelectorAll('[data-js-product-variant-container]').forEach(function (elm) {
      if (elm.dataset.jsProductVariantContainer === 'radio') {
        var inp = elm.querySelector('input.product-variant__input:checked, input[type="radio"]:checked');
        if (inp) out.push(inp.value);
      } else {
        if (!(variantRequired && elm.selectedIndex === 0)) {
          out.push(elm.value);
        }
      }
    });
    return out;
  }

  function parseColorData(card) {
    var el = card.querySelector('[data-sh-related-color-data]');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  /** Linked Farbe: product id whose colorLabel matches any main option value. */
  function findLinkedColorProductId(card, mainOptions) {
    var list = parseColorData(card);
    if (!list || !list.length || !mainOptions || !mainOptions.length) return null;

    for (var mi = 0; mi < mainOptions.length; mi++) {
      var mv = norm(mainOptions[mi]);
      if (!mv) continue;
      for (var i = 0; i < list.length; i++) {
        var lab = norm(list[i].colorLabel || list[i].title || '');
        if (lab && mv === lab) {
          return String(list[i].id);
        }
      }
    }
    return null;
  }

  function optionExists(select, value) {
    return Array.prototype.some.call(select.options, function (o) {
      return o.value === value;
    });
  }

  function setSelectByMainValue(select, mainValue) {
    if (mainValue == null || mainValue === '') return false;
    if (optionExists(select, mainValue)) {
      select.value = mainValue;
      return true;
    }
    var mv = norm(mainValue);
    for (var i = 0; i < select.options.length; i++) {
      if (norm(select.options[i].value) === mv) {
        select.selectedIndex = i;
        return true;
      }
    }
    return false;
  }

  function applyVariantSelectsFromMain(card, mainOptions) {
    if (!mainOptions || !mainOptions.length) return;
    card.querySelectorAll('[data-sh-related-option]').forEach(function (sel) {
      var idx = parseInt(sel.getAttribute('data-option-index'), 10);
      if (isNaN(idx) || idx < 0 || idx >= mainOptions.length) return;
      setSelectByMainValue(sel, mainOptions[idx]);
    });
  }

  function fireRelatedVariantChange(card) {
    var sel = card.querySelector('[data-sh-related-option]');
    if (sel) {
      sel.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function syncOneCard(card) {
    var mainOptions = getMainProductOptionValues();
    if (!mainOptions.length) return;

    var colorSel = card.querySelector('[data-sh-related-color-select]');
    if (colorSel) {
      var pid = findLinkedColorProductId(card, mainOptions);
      if (pid && optionExists(colorSel, pid)) {
        colorSel.value = pid;
        colorSel.dispatchEvent(new Event('change', { bubbles: true }));
        window.requestAnimationFrame(function () {
          window.requestAnimationFrame(function () {
            applyVariantSelectsFromMain(card, mainOptions);
            fireRelatedVariantChange(card);
          });
        });
        return;
      }
    }

    applyVariantSelectsFromMain(card, mainOptions);
    fireRelatedVariantChange(card);
  }

  function syncAllRelatedCards() {
    document.querySelectorAll('.sh-related-products-wrap [data-sh-related-card]').forEach(syncOneCard);
  }

  function bindMainVariantListener() {
    var pv = findMainProductVariants();
    if (!pv || pv._shRelatedMainSyncBound) return;
    pv._shRelatedMainSyncBound = true;
    pv.addEventListener('VARIANT_CHANGE', function () {
      window.requestAnimationFrame(syncAllRelatedCards);
    });
  }

  function boot() {
    if (!document.querySelector('.sh-related-products-wrap')) return;

    function run() {
      if (!findMainProductVariants()) return;
      syncAllRelatedCards();
      bindMainVariantListener();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        window.requestAnimationFrame(function () {
          window.requestAnimationFrame(run);
        });
      });
    } else {
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(run);
      });
    }

    window.setTimeout(function () {
      if (findMainProductVariants()) {
        syncAllRelatedCards();
        bindMainVariantListener();
      }
    }, 200);
  }

  document.addEventListener('shopify:section:load', function () {
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        if (document.querySelector('.sh-related-products-wrap')) {
          syncAllRelatedCards();
          bindMainVariantListener();
        }
      });
    });
  });

  boot();
})();
